export default {
  admin: 'Administrador',
  password: {
    enterNewPassword: 'Insira uma nova senha',
    reenterNewPassword: 'Digite novamente a nova senha',
    updatePassword: 'Atualizar senha',
    setPassword: 'Definir senha',
    min8CharacterMessage: 'A senha deve ter pelo menos 8 caracteres',
    passwordSentMessage: 'A senha foi enviada para {userName} por e-mail.',
    generateNewPassword: 'Gerar nova senha',
    assignPasswordMessage:
      'Atribua uma senha ao usuário. O usuário será obrigado a alterar essa senha no próximo login.',
    generateSecurePassword: 'Gerar senha segura',
    newPassword: 'Nova senha',
    confirmNewPassword: 'Confirmar nova senha',
    passwordHistory: 'Histórico de senhas',
    passwordUpdatedLog: 'Senha atualizada por {userName} em {date}.',
    forgotPasswordLog: 'Solicitação de recuperação de senha enviada por {userName} em {date}.',
  },
};
